export const getColorAlias = (color, alias) => {
  let colorAlias = "";
  switch (color) {
    case "WHITE":
      colorAlias = alias.bfcWhite;
      break;
    case "RED":
      colorAlias = alias.bfcRed;
      break;
    case "GREY":
      colorAlias = alias.bfcGrey;
      break;
    case "MATT_BLACK":
      colorAlias = alias.bfcBlack;
      break;
    case "TEXTURED_BLACK":
      colorAlias = alias.bfcTexturedBlack;
      break;
    case "VIT":
      colorAlias = alias.bfcWhite;
      break;
    case "GREYDARK":
      colorAlias = alias.bfcGreyDark;
      break;
    case "SVART":
      colorAlias = alias.bfcBlack;
      break;
    case "GRÅ":
      colorAlias = alias.bfcGrey;
      break;
    case "VANILLA":
      colorAlias = alias.bfcVanilla;
      break;
    case "CONCRETE":
      colorAlias = alias.bfcConcrete;
      break;
    case "GRAPHITE":
      colorAlias = alias.bfcGraphite;
      break;
    case "ANTHRACITE":
      colorAlias = alias.bfcAnthracite;
      break;
    case "LINEN":
      colorAlias = alias.bfcLinen;
      break;

    default:
      break;
  }
  return colorAlias;
};
